/**
 * Static-translations for vi. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const vi = {
  'anon.heading_default': 'Tiếp tục với tư cách khách',
  'anon.try_again': 'Thử lại',
  'auth.back_to_login': 'Quay lại đăng nhập',
  'auth.check_email_message': 'Kiểm tra email của bạn để xem mã xác nhận.',
  'auth.check_email_title': 'Kiểm tra email của bạn',
  'auth.confirm_email_title': 'Xác nhận email của bạn',
  'auth.confirmation_code': 'Mã xác nhận',
  'auth.continue_with_apple': 'Tiếp tục với Apple',
  'auth.continue_with_facebook': 'Tiếp tục với Facebook',
  'auth.continue_with_github': 'Tiếp tục với GitHub',
  'auth.continue_with_google': 'Tiếp tục với Google',
  'auth.create_account': 'Tạo tài khoản',
  'auth.default_subtitle': 'Đăng nhập để truy cập tất cả tính năng và đồng bộ dữ liệu của bạn.',
  'auth.email': 'Địa chỉ email',
  'auth.email_already_registered': 'Email này đã được đăng ký. Đăng nhập bên dưới bằng mật khẩu hoặc tài khoản bạn đã dùng để đăng ký.',
  'auth.email_exists': 'Tài khoản với email này đã tồn tại.',
  'auth.email_not_confirmed': 'Vui lòng xác nhận email trước.',
  'auth.forgot_password': 'Quên mật khẩu?',
  'auth.forgot_password_title': 'Quên mật khẩu?',
  'auth.forgot_subtitle': 'Nhập email của bạn và chúng tôi sẽ gửi liên kết đặt lại mật khẩu.',
  'auth.generic_error': 'Đã xảy ra lỗi',
  'auth.have_account': 'Đã có tài khoản?',
  'auth.hide_password': 'Ẩn mật khẩu',
  'auth.identity_already_linked': 'Tài khoản này đã được đăng ký. Đăng nhập bằng tài khoản này bên dưới.',
  'auth.invalid_credentials': 'Email hoặc mật khẩu không đúng',
  'auth.invalid_otp': 'Mã không hợp lệ hoặc đã hết hạn.',
  'auth.last_used': 'Dùng gần nhất · {email}',
  'auth.last_used_no_email': 'Dùng gần nhất',
  'auth.link_purchase_subheading': 'Chúng tôi sẽ liên kết giao dịch với tài khoản của bạn để giữ quyền truy cập.',
  'auth.log_in': 'Đăng nhập',
  'auth.log_in_link': 'Đăng nhập',
  'auth.login_continue_purchase': 'Đăng nhập để tiếp tục giao dịch',
  'auth.network_error': 'Lỗi mạng. Vui lòng kiểm tra kết nối và thử lại.',
  'auth.no_account': 'Chưa có tài khoản?',
  'auth.or': 'hoặc',
  'auth.password': 'Mật khẩu',
  'auth.passwords_mismatch': 'Mật khẩu không khớp',
  'auth.rate_limited': 'Quá nhiều yêu cầu. Vui lòng thử lại sau.',
  'auth.repeat_password': 'Nhập lại mật khẩu',
  'auth.reset_link_valid': 'Liên kết có hiệu lực trong 1 giờ.',
  'auth.reset_password_title': 'Đặt lại mật khẩu',
  'auth.reset_sent_message': 'Nếu email đó tồn tại, mã đặt lại đã được gửi.',
  'auth.reset_sent_subtitle': 'Chúng tôi đã gửi liên kết đặt lại mật khẩu. Làm theo hướng dẫn trong email.',
  'auth.restore_purchases_heading': 'Khôi phục giao dịch',
  'auth.restore_purchases_subheading': 'Vui lòng đăng nhập để khôi phục giao dịch của bạn.',
  'auth.send_reset': 'Gửi email đặt lại',
  'auth.service_unavailable': 'Dịch vụ tạm thời không khả dụng. Vui lòng thử lại sau.',
  'auth.show_password': 'Hiện mật khẩu',
  'auth.sign_out': 'Đăng xuất',
  'auth.sign_up': 'Đăng ký',
  'auth.sign_up_link': 'Đăng ký',
  'auth.signed_in': 'Đã đăng nhập',
  'auth.signin_failed': 'Đăng nhập thất bại',
  'auth.signup_failed': 'Đăng ký thất bại',
  'auth.verify': 'Xác minh',
  'auth.weak_password': 'Mật khẩu quá yếu.',
  'auth.welcome': 'Chào mừng!',
  'auth.welcome_signup': 'Chào mừng!',
  'cta.close': 'Đóng',
  'cta.continue': 'Tiếp tục',
  'cta.get_lifetime_access': 'Nhận quyền truy cập trọn đời',
  'cta.get_plan_daily': 'Chọn gói hằng ngày',
  'cta.get_plan_monthly': 'Chọn gói hằng tháng',
  'cta.get_plan_weekly': 'Chọn gói hằng tuần',
  'cta.get_plan_yearly': 'Chọn gói hằng năm',
  'cta.start_trial': 'Bắt đầu dùng thử {days} ngày miễn phí',
  'modal.close_aria': 'Đóng',
  'modal.continue': 'Tiếp tục',
  'modal.error_generic': 'Đã xảy ra lỗi',
  'modal.loading': 'Đang tải…',
  'modal.purchase_restored_subtitle': 'Mọi thứ đã sẵn sàng — chúc bạn vui vẻ!',
  'modal.purchase_restored_title': 'Chào mừng trở lại',
  'modal.purchase_success_subtitle': 'Mọi thứ đã sẵn sàng — chúc bạn vui vẻ!',
  'modal.purchase_success_title': 'Đã nhận thanh toán',
  'modal.verifying_subscription': 'Đang kiểm tra đăng ký…',
  'nav.back': '← Quay lại',
  'nav.back_aria': 'Quay lại',
  'offer.limited_time': 'Ưu đãi có thời hạn',
  'payment.awaiting_title': 'Hoàn tất thanh toán trong tab mới',
  'payment.checking': 'Đang kiểm tra…',
  'payment.ive_paid': 'Tôi đã thanh toán',
  'payment.open_checkout_again': 'Mở lại thanh toán',
  'payment.open_checkout_button': 'Mở thanh toán',
  'pricing.free_trial_days': '{days} ngày dùng thử miễn phí',
  'pricing.included_per': 'Bao gồm mỗi {interval}:',
  'pricing.interval.day': 'ngày',
  'pricing.interval.lifetime_short': 'trọn đời',
  'pricing.interval.month': 'tháng',
  'pricing.interval.period': 'kỳ',
  'pricing.interval.week': 'tuần',
  'pricing.interval.year': 'năm',
  'pricing.money_back': 'Đảm bảo hoàn tiền trong 30 ngày',
  'pricing.most_popular': 'Phổ biến nhất',
  'pricing.no_prices': 'Không có giá khả dụng.',
  'pricing.plan_label.daily': 'GÓI HẰNG NGÀY',
  'pricing.plan_label.lifetime': 'trọn đời',
  'pricing.plan_label.monthly': 'gói hàng tháng',
  'pricing.plan_label.weekly': 'gói hàng tuần',
  'pricing.plan_label.yearly': 'gói hàng năm',
  'pricing.plans_aria': 'Gói',
  'session.contact_support': 'Liên hệ hỗ trợ',
  'session.restore_purchases': 'Khôi phục mua hàng',
  'session.sign_out': 'Đăng xuất',
  'session.signed_in_as_prefix': 'Đã đăng nhập với tư cách',
  'session.signing_out': 'Đang đăng xuất…',
  'support.attachments_label': 'Tệp đính kèm',
  'support.close_button': 'Đóng',
  'support.done_button': 'Xong',
  'support.email_placeholder': 'Nhập email của bạn',
  'support.heading': 'Hỗ trợ',
  'support.instruction': 'Vui lòng điền vào biểu mẫu bên dưới để gửi yêu cầu hỗ trợ của bạn.',
  'support.invalid_email': 'Email không hợp lệ',
  'support.message_length': '1–5000 ký tự',
  'support.message_placeholder': 'Nhập tin nhắn của bạn',
  'support.required': 'Bắt buộc',
  'support.send_another': 'Gửi yêu cầu khác',
  'support.send_button': 'Gửi',
  'support.sending': 'Đang gửi…',
  'support.subject_length': '3–200 ký tự',
  'support.subject_placeholder': 'Nhập tiêu đề',
  'support.success_heading': 'Yêu cầu đã được gửi',
  'support.success_message_prefix': 'Chúng tôi đã nhận được tin nhắn của bạn và sẽ phản hồi đến'
} as const;

export default vi;
